import { useToggle } from '@gameonsports/components/cjs/_hooks/useToggle'
import Button from '@gameonsports/components/cjs/Button'
import { Text } from '@gameonsports/components/cjs/TextV3'
import { useLocation } from '@reach/router'
import React from 'react'
import styled from 'styled-components'
import { Regions, regionToLinksMap } from '../../../constants/states'
import useOnOutsideClick from '../../../hooks/useOnOutsideClick'

const RegionChangeContainer = styled.div`
  position: relative;
`

const RegionChangeButton = styled(Button)`
  background-color: #1e286e;
  border-color: #1e286e;
`

const RegionChangerDropdown = styled.nav`
  width: 7rem;
  margin-top: 0.25rem;
  position: absolute;
  top: 100%;
  left: 0;
  border-radius: 3px;
  padding: 0.5rem 1rem;
  background: ${props => props.theme.white400};
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
`

const RegionChangerLink = styled.a`
  display: block;
  padding: 0.5rem 0.25rem;
  cursor: pointer;
  text-decoration: none;
  outline: none;
  transition: color 150ms ${props => props.theme.easeInOutCirc};

  &:hover,
  &:focus {
    color: ${props => props.theme.blueberry400};
  }
`

const DropdownNavList = styled.ul`
  padding: 0;
  margin: 0;
  list-style-type: none;
`

export const RegionChangerHeader = () => {
  const regionChangerDropdownRef = React.createRef<HTMLDivElement>()
  const [regionChangerOpen, toggleRegionChangerOpen] = useToggle(false)
  const location = useLocation()

  const closeRegionChanger = () => {
    if (!regionChangerOpen) return

    toggleRegionChangerOpen()
  }

  useOnOutsideClick(regionChangerDropdownRef, closeRegionChanger)

  const regionOptions = Object.values(Regions)

  return (
    <RegionChangeContainer
      ref={regionChangerDropdownRef}
      data-testid="region-changer-header"
    >
      <RegionChangeButton
        type="button"
        size="small"
        variant="primary"
        icon="down-arrow"
        iconPosition="right"
        iconSize="12"
        onClick={() => toggleRegionChangerOpen()}
      >
        {location.pathname.startsWith('/uk') ? 'UK' : 'AU & NZ'}
      </RegionChangeButton>
      {regionChangerOpen && (
        <RegionChangerDropdown data-testid="region-changer-header-dropdown">
          <DropdownNavList>
            {regionOptions.map(region => {
              return (
                <li key={region}>
                  <RegionChangerLink
                    href={regionToLinksMap[region]}
                    data-testid="account-link"
                  >
                    <Text size="14">{region}</Text>
                  </RegionChangerLink>
                </li>
              )
            })}
          </DropdownNavList>
        </RegionChangerDropdown>
      )}
    </RegionChangeContainer>
  )
}
